export const types = {
  SET_PRODUCT_CHANNEL: 'SET_PRODUCT_CHANNEL',
  SET_PRODUCT_ID: 'SET_PRODUCT_ID',
}

const mutations = {
  [types.SET_PRODUCT_CHANNEL]: (state, payload) => {
    Object.assign(state, {
      ...payload,
    })
  },
  [types.SET_PRODUCT_ID](state, payload) {
    state.productId = payload
  },
}

export default mutations
